import {
  DynamicAttributeFieldListFragment,
  DynamicAttributeType,
} from "gql/graphql";
import {
  FALSE,
  TRUE,
} from "@/shared/dynamic-attributes/ui/dynamic-attribute-field/dynamic-attribute-field-simple/dynamic-attribute-field-simple-boolean-select-values";
import { FilterObject } from "@/shared/filters-by-meta/model/types";

export function normalizeFilter(
  filter: FilterObject | null | undefined,
  meta: DynamicAttributeFieldListFragment,
) {
  if (filter === null || filter === undefined) {
    return filter;
  }

  return Object.fromEntries(
    Object.entries(filter).map(([key, value]) => {
      const attribute = meta.attributes.find(
        (attribute) => attribute.attributeCode === key,
      );

      if (attribute?.__typename === "SimpleTypeDynamicAttributeDto") {
        switch (attribute.type) {
          case DynamicAttributeType.Boolean:
            return value === TRUE
              ? [key, true]
              : value === FALSE
                ? [key, false]
                : [key, null];

          case DynamicAttributeType.Number:
            return [key, Number(value)];
        }
      }

      return [key, value];
    }),
  );
}
